import { CelebrationDrawer } from "@components/adapters/celebration/Drawer";
import type { DrawerProps } from "@components/contracts/Drawer.types";

export const Drawer: React.FC<DrawerProps> = (props) => (
  <CelebrationDrawer {...props} />
);

export type { DrawerProps };
